/* Sami email-look v20260924-4. Progressive enhancement; native Eurus purchasing. */
(() => {
  if (window.SamiEmailLook) return;
  const state = { version: "20260924-4", opener: null, observer: null };
  window.SamiEmailLook = state;

  function watchNativeClose(modal) {
    if (state.observer) return;
    state.observer = new MutationObserver(() => {
      if (!state.opener || modal.style.display !== "none") return;
      const opener = state.opener;
      state.opener = null;
      // Do not steal focus from the cart or another native dialog.
      if (opener.isConnected &&
          (modal.contains(document.activeElement) || document.activeElement === document.body)) {
        opener.focus({ preventScroll: true });
      }
    });
    state.observer.observe(modal, { attributes: true, attributeFilter: ["style"] });
  }

  // Eurus deliberately skips its focus trap below 1025px. Supply it only
  // for dialogs opened by this section, without changing global Quick View.
  document.addEventListener("keydown", event => {
    const modal = document.getElementById("QuickView");
    if (!state.opener || !window.Alpine?.store("xQuickView")?.show || !modal) return;
    if (!modal.contains(document.activeElement) && document.activeElement !== state.opener) return;
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.Alpine.store("xQuickView").close();
      return;
    }
    if (event.key !== "Tab" || window.innerWidth >= 1025) return;
    const focusable = [...modal.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )].filter(el => el.tabIndex >= 0 && el.getClientRects().length &&
      getComputedStyle(el).visibility !== "hidden");
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener("click", event => {
    if (event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest("[data-sami-look-anchor]");
    if (anchor) {
      const heading = document.getElementById(anchor.hash.slice(1));
      if (!heading) return;
      event.preventDefault();
      // Eurus can leave --height-header at 0 even with a sticky header.
      // Measure the real header instead of trusting that CSS variable.
      const headerHeight = document.querySelector(".section-header")?.getBoundingClientRect().height || 0;
      const y = window.scrollY + heading.getBoundingClientRect().top - headerHeight - 24;
      window.scrollTo({ top: Math.max(0, y), behavior: "instant" });
      heading.focus({ preventScroll: true });
      return;
    }

    const link = event.target.closest("[data-sami-look-quickview]");
    if (!link) return;
    const quickView = window.Alpine?.store("xQuickView");
    const modal = document.getElementById("QuickView");
    if (!quickView?.enabled || !modal ||
        typeof quickView.load !== "function" || typeof quickView.open !== "function") return;
    // The normal product href remains usable before JS initializes or if Quick View is disabled.
    event.preventDefault();
    try {
      state.opener = link;
      watchNativeClose(modal);
      quickView.load(link.dataset.samiLookQuickview, link, link.dataset.samiLookOptionId);
      quickView.open();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (state.opener === link && quickView.show &&
            !document.body.classList.contains("klaviyo-prevent-body-scrolling")) {
          document.getElementById("QuickViewClose")?.focus({ preventScroll: true });
        }
      }));
      window.Alpine.store("xCustomerEvent")?.fire("product_selected", link);
    } catch (error) {
      state.opener = null;
      window.location.assign(link.href);
    }
  });
})();
